// extracted by mini-css-extract-plugin
export default {"eventWrapper":"CalendarPage_eventWrapper__yune9","wrapperButton":"CalendarPage_wrapperButton__mH5hr","toolbar":"CalendarPage_toolbar__o3u+-","title":"CalendarPage_title__mZhVm"};